<template>
  <div>
    <p class="text-secondary font-weight-bold mt-4">
      {{ $t('chargesCalc.tableHeadings.calculationDetails') }}
    </p>
    <b-card>
      <b-table
        class="calc-table holiday-table"
        borderless
        :items="tableBreakupItems"
        :fields="tableBreakupFields"
      >
        <template v-slot:head(asOn)="data">
          <div
            class="d-flex flex-column flex-md-row align-items-center justify-center"
          >
            <div>
              <span>{{ data.label }}</span>
              <tool-tip
                :title="$t('chargesCalc.calcDetailsTable.toolTips.dueDate')"
                shade="dark"
              />
            </div>
            <div class="date-picker-container position-relative flex-grow-1">
              <date-picker
                v-model="selectedDate"
                format="MM/DD/YYYY"
                @change="selectDate"
              />
            </div>
          </div>
        </template>
        <template v-slot:head(expectedOnDueDate)="data">
          {{ data.label }}
          <tool-tip
            :title="$t('chargesCalc.calcDetailsTable.toolTips.expectedDate')"
            shade="dark"
          />
        </template>
        <template v-slot:cell()="data">
          <div v-html="data.value"></div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import ToolTip from '@/components/common/ToolTip'
import 'vue2-datepicker/index.css'

export default {
  components: {
    DatePicker,
    ToolTip
  },
  props: ['tableBreakupItems', 'tableBreakupFields', 'options'],
  data() {
    return {
      selectedDate: new Date()
    }
  },
  methods: {
    selectDate() {
      this.$emit('dateChange', this.selectedDate)
    }
  }
}
</script>
